export function hrAccessibleUsersFilter(user: {
  isHrAdmin: boolean
  canManageHolidayRequests: boolean
  hrAccessibleBranches: { id: string }[]
  hrManagedUsers: { id: string }[]
}) {
  const { hrAccessibleBranches, hrManagedUsers, isHrAdmin, canManageHolidayRequests } = user
  const accessibleFilter = []
  if (!canManageHolidayRequests && !isHrAdmin) {
    return null
  }
  if (isHrAdmin) {
    accessibleFilter.push({
      exists: {
        path: [
          {
            name: "branch",
            filter: {
              and: [
                { not: { matches: { name: { like: "test" } } } },
                { not: { matches: { name: { like: "demo" } } } },
                { not: { matches: { name: { like: "training" } } } },
              ].filter(Boolean),
            },
          },
        ],
      },
    })
  } else if (hrAccessibleBranches.length > 0) {
    accessibleFilter.push({
      matches: { baseBranch: { or: hrAccessibleBranches.map(x => x.id) } },
    })
  }
  if (hrManagedUsers.length > 0) {
    accessibleFilter.push({
      matches: { id: { or: hrManagedUsers.map(user => user.id) } },
    })
  }
  if (accessibleFilter.length === 0) {
    return null
  }
  return { or: accessibleFilter }
}
